import { createContext, PropsWithChildren, useMemo } from 'react';
import { HqoClientSdk } from '@hqo/hqo-miniapp-client-sdk';
import { useContextValue } from 'app/shared/hooks/use-context-value';
import { useUiMetadataQuery } from 'app/data/queries/use-ui-metadata-query';

const MiniappSdkContext = createContext<HqoClientSdk | null>(null);

export const MiniappSdkProvider = ({ children }: PropsWithChildren): JSX.Element => {
  const { uiMetadata } = useUiMetadataQuery();
  const appUuid = uiMetadata?.app_uuid;
  const miniappSdkClient = useMemo(
    () => new HqoClientSdk({
      develop: false,
      app_uuid: appUuid || '',
      init_timeout: undefined,
    }),
    [appUuid],
  );

  const contextValue = useMemo(() => miniappSdkClient, [miniappSdkClient]);

  return <MiniappSdkContext.Provider value={contextValue}>{children}</MiniappSdkContext.Provider>;
};

export const useMiniappSdk = (): HqoClientSdk => useContextValue(MiniappSdkContext) as HqoClientSdk;

export { MiniappSdkContext };
